class MaterialButtonComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.onUpdate(event.detail), true)
    document.addEventListener('material-changed', (event) => this.onUpdate(event.detail), true)
  }

  onUpdate(project) {
    document.getElementById('material-panel-text').innerHTML = project.materialName
  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <a href="#" data-toggle="modal" data-target="#modal-material-selector-dialog">
        <div class="panel panel-primary panel-shadow text-center">
          <div id="material-panel-text" class="panel-heading" style="font-size: 18px;">Steel A992</div>
          <div class="panel-body hidden-print">
            <span class="pull-left">Change material...</span>
            <span class="pull-right hidden-md hidden-sm hidden-xs"><i class="fa fa-edit"></i></span>
          </div>
        </div>
      </a>
    `
  }
}

customElements.define('material-button-component', MaterialButtonComponent);

        